import styled, {css} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import Feather from 'react-native-vector-icons/Feather';

interface Package {
  active: boolean;
}

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const IconContainer = styled.View`
  width: ${RFValue(50)}px;
  height: ${RFValue(50)}px;
  background-color: ${({theme}) => theme.colors.background};
  justify-content: center;
  align-items: center;
  margin-right: ${RFValue(12)}px;
  border-radius: ${RFValue(12)}px;
`;

export const StationContainer = styled.TouchableOpacity`
  margin-top: ${RFValue(12)}px;
  flex-direction: row;

  align-items: center;
`;

export const StationMapIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
`;

export const StationInfosTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const StationInfosContainer = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;
export const StationInfos = styled.View`
  margin-left: ${RFValue(10)}px;
`;

//@ts-ignore
export const StationImage = styled(FastImage)`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(8)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
`;
export const StationTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
`;
export const StationDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
`;

//@ts-ignore
export const FuelImage = styled(FastImage)`
  width: 100%;
  height: 100%;
  border-radius: ${RFValue(12)}px;
`;

export const AlertContainer = styled.View`
  padding: 0 16px;
  margin: 0 -16px;
`;

export const Info = styled.View`
  justify-content: flex-start;
  align-items: center;

  flex-direction: row;

  margin: 0 24px;
  margin-bottom: ${RFValue(12)}px;
`;

export const ProductInfos = styled.View`
  flex: 1;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Content = styled.ScrollView`
  flex: 1;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;

  font-family: ${({theme}) => theme.fonts.regular};
`;

export const Price = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  margin-right: ${RFValue(6)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const PriceInfo = styled.View`
  flex-direction: row;
`;

export const LiterBadge = styled.View`
  background: ${({theme}) => theme.colors.background_secondary};
  padding: ${RFValue(2)}px ${RFValue(10)}px;
  border-radius: ${RFValue(20)}px;
  border: 1px solid ${({theme}) => theme.colors.border};
  margin-left: ${RFValue(4)}px;
`;

export const Liter = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const Section = styled.View`
  margin-top: ${RFValue(12)}px;
  padding: 0 24px;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};

  margin-top: ${RFValue(16)}px;
  padding-top: ${RFValue(16)}px;
`;

export const List = styled.View`
  margin-top: ${RFValue(12)}px;
`;

export const SectionHeader = styled.View`
  margin: ${RFValue(12)}px 0;
 
  padding: 0 24px;
    border-top-width: 1px;
    padding-top: ${RFValue(16)}px;
  border-top-color: ${({theme}) => theme.colors.border};

`;

export const SectionTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const QuantityRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export const Description = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const PackageSelect = styled.TouchableOpacity<Package>`
  flex: 1;
  justify-content: center;
  align-items: center;
  margin: 6px;
  border: 2px solid ${({theme}) => theme.colors.border};
  border-radius: ${RFValue(12)}px;

  ${({active, theme}) =>
    active &&
    css`
      border-color: ${theme.colors.blue};
    `}
`;

export const PackageSelectValue = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const PackageSelectValueDescription = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(10)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const QuantityContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const QuantityButton = styled.TouchableOpacity`
  width: ${RFValue(25)}px;
  height: ${RFValue(25)}px;
  align-items: center;
  justify-content: center;
  border-radius: ${RFValue(20)}px;
  border: 1px solid ${({theme}) => theme.colors.border};
`;
export const QuantityIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
`;
export const Quantity = styled.Text`
  padding: 0 ${RFValue(8)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: ${RFValue(12)}px;
`;

export const LinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
`;

export const LinkButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const SectionDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  margin-top: ${RFValue(12)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-top: ${RFValue(12)}px;
  padding-bottom: ${getBottomSpace() && Platform.OS === 'ios'
    ? 0
    : RFValue(20)}px;
`;
